import pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

// pdfMake fontlarını kaydet
if (pdfFonts && pdfFonts.pdfMake && pdfFonts.pdfMake.vfs) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
} else if (pdfFonts) {
    pdfMake.vfs = pdfFonts;
}

/**
 * Arızalı Yedek Parça İade Dökümü PDF (pdfMake ile)
 * Türkçe karakter desteği tam olarak çalışır
 */
class ReturnRequestPdfFormPdfMake {
    /**
     * PDF'i oluşturur
     */
    generate(data, translations = {}) {
        const docDefinition = {
            pageSize: 'A4',
            pageMargins: [40, 40, 40, 40],
            content: [
                // Başlık - Logo ve Form Başlığı
                this.createHeader(translations),
                { text: '', margin: [0, 10] },

                // Üst Bilgiler
                this.createTopSection(data, translations),
                { text: '', margin: [0, 5] },

                // Arızalı Parça Bilgileri (koşullu - sadece isFaulty true ise göster)
                ...(data.isFaulty ? [
                    this.createFaultyPartInfoSection(data, translations),
                    { text: '', margin: [0, 5] }
                ] : []),

                // Parça Detayları Tablosu
                this.createPartDetailsTable(data, translations),
                { text: '', margin: [0, 5] },

                // Yedek Servis Kaşesi
                this.createServiceStampSection(data, translations)
            ],
            defaultStyle: {
                font: 'Roboto'
            }
        };

        return pdfMake.createPdf(docDefinition);
    }

    /**
     * Başlık - Logo ve Form Başlığı
     */
    createHeader(translations) {
        return {
            columns: [
                {
                    // Sol: KARSAN Logo
                    width: 'auto',
                    columns: [
                        {
                            width: 35,
                            canvas: [
                                { type: 'polyline', points: [{ x: 0, y: 0 }, { x: 18, y: 0 }, { x: 1, y: 18 }], color: '#F05133', closePath: true },
                                { type: 'polyline', points: [{ x: 0, y: 36 }, { x: 18, y: 36 }, { x: 1, y: 18 }], color: '#F05133', closePath: true },
                                { type: 'rect', x: 0, y: 0, w: 1, h: 36, color: '#F05133' },
                                { type: 'polyline', points: [{ x: 36, y: 0 }, { x: 36, y: 36 }, { x: 18, y: 18 }], color: '#F05133', closePath: true }
                            ]
                        },
                        {
                            text: 'KARSAN',
                            fontSize: 14,
                            bold: true,
                            color: '#76777A',
                            margin: [5, 8, 0, 0]
                        }
                    ]
                },
                {
                    // Sağ: Form Başlığı
                    text: translations.title || 'Arızalı Yedek Parça İade Dökümü',
                    fontSize: 10,
                    color: '#666666',
                    alignment: 'right',
                    width: '*',
                    margin: [0, 5, 0, 0]
                }
            ]
        };
    }

    /**
     * Üst Bilgiler
     */
    createTopSection(data, translations) {
        return {
            stack: [
                // Satır 1: Servis Kodu, Servis Adı, Talep Tarihi
                {
                    columns: [
                        this.createField(translations.serviceCode || 'Servis Kodu', data.serviceCode || '', '31%'),
                        { width: '3.5%', text: '' },
                        this.createField(translations.serviceName || 'Servis Adı', data.serviceName || '', '31%'),
                        { width: '3.5%', text: '' },
                        this.createField(translations.requestDate || 'Talep Tarihi', data.requestDate || '', '31%')
                    ]
                },
                { text: '', margin: [0, 0] },
                // Satır 2: İade No, Açıklama
                {
                    columns: [
                        this.createField(translations.returnNo || 'İade No', data.returnNo || '', '48%'),
                        { width: '4%', text: '' },
                        this.createField(translations.description || 'Açıklama', data.description || '', '48%', true)
                    ]
                },
                { text: '', margin: [0, 0] },
                // Satır 3: Şasi No
                this.createField(translations.chassisNo || 'Şasi No', data.vinOrChassisNo || '', '100%')
            ]
        };
    }

    /**
     * Parça Detayları Tablosu
     */
    createPartDetailsTable(data, translations) {
        const tableBody = [
            [
                { text: data.partCode || '-', fontSize: 8, alignment: 'center' },
                { text: data.partName || '-', fontSize: 8, alignment: 'left' },
                { text: (data.quantity || '-').toString(), fontSize: 8, alignment: 'center' },
                { text: '-', fontSize: 8, alignment: 'left' },
                { text: data.faultDesc || '-', fontSize: 8, alignment: 'left' },
                { text: data.invoiceNo || '-', fontSize: 8, alignment: 'center' },
                { text: data.invoiceDate || '-', fontSize: 8, alignment: 'center' }
            ]
        ];

        return {
            table: {
                widths: [60, 90, 30, 60, 80, 50, 60],
                body: [
                    [
                        { text: translations.partCode || 'Parça Kodu', fontSize: 8, bold: true, fillColor: '#273A81', color: '#FFFFFF', alignment: 'center' },
                        { text: translations.partName || 'Parça Adı', fontSize: 8, bold: true, fillColor: '#273A81', color: '#FFFFFF', alignment: 'center' },
                        { text: translations.quantity || 'Adet', fontSize: 8, bold: true, fillColor: '#273A81', color: '#FFFFFF', alignment: 'center' },
                        { text: translations.faultyReason || 'Neden Arızalı', fontSize: 8, bold: true, fillColor: '#273A81', color: '#FFFFFF', alignment: 'center' },
                        { text: translations.explanation || 'Açıklama', fontSize: 8, bold: true, fillColor: '#273A81', color: '#FFFFFF', alignment: 'center' },
                        { text: translations.invoiceNo || 'Fatura No', fontSize: 8, bold: true, fillColor: '#273A81', color: '#FFFFFF', alignment: 'center' },
                        { text: translations.invoiceDate || 'Fatura Tarihi', fontSize: 8, bold: true, fillColor: '#273A81', color: '#FFFFFF', alignment: 'center' }
                    ],
                    ...tableBody
                ]
            },
            layout: {
                hLineWidth: () => 0.5,
                vLineWidth: () => 0.5,
                hLineColor: () => '#E9ECEF',
                vLineColor: () => '#E9ECEF'
            }
        };
    }

    /**
     * Arızalı Parça Bilgileri Bölümü
     */
    createFaultyPartInfoSection(data, translations) {
        return {
            stack: [
                // Satır 1: Parça Montaj Tarihi, Parça Arıza Tarihi, Gün Ay Yıl
                {
                    columns: [
                        this.createField(translations.assemblyDate || 'Parça Montaj Tarihi', data.assemblyDate || '-', '31%'),
                        { width: '3.5%', text: '' },
                        this.createField(translations.faultDate || 'Parça Arıza Tarihi', data.faultDate || '-', '31%'),
                        { width: '3.5%', text: '' },
                        this.createField(translations.dayMonthYearDiff || 'Gün Ay Yıl', data.dayMonthYearDiff || '-', '31%')
                    ]
                },
                { text: '', margin: [0, 0] },
                // Satır 2: Parça Montaj Km, Parça Arıza Km, Km Fark
                {
                    columns: [
                        this.createField(translations.assemblyKm || 'Parça Montaj Km', data.assemblyKm !== null && data.assemblyKm !== undefined ? data.assemblyKm.toString() : '-', '31%'),
                        { width: '3.5%', text: '' },
                        this.createField(translations.faultKm || 'Parça Arıza Km', data.faultKm !== null && data.faultKm !== undefined ? data.faultKm.toString() : '-', '31%'),
                        { width: '3.5%', text: '' },
                        this.createField(translations.kmDiff || 'Km Fark', data.kmDiff !== null && data.kmDiff !== undefined ? data.kmDiff.toString() : '-', '31%')
                    ]
                }
            ]
        };
    }

    /**
     * Yedek Servis Kaşesi Bölümü
     */
    createServiceStampSection(data, translations) {
        return {
            table: {
                widths: ['*'],
                heights: [35],
                body: [
                    [
                        {
                            columns: [
                                {
                                    stack: [
                                        { text: translations.serviceStamp || 'Yedek Servis Kaşesi', fontSize: 9, color: '#666666' },
                                        { text: '', margin: [0, 5] },
                                        { text: translations.authorizedSignature || 'Yetkili Adı, Soyadı ve İmzası', fontSize: 8, color: '#666666' },
                                        {
                                            canvas: [{ type: 'rect', x: 0, y: 2, w: 250, h: 10, lineWidth: 0.3, lineColor: '#E9ECEF' }]
                                        }
                                    ],
                                    width: '75%'
                                },
                                {
                                    stack: [
                                        { text: translations.date || 'Tarih', fontSize: 8, color: '#666666', alignment: 'left' },
                                        { text: data.printDate || '', fontSize: 10, bold: true, color: '#2C3E50', margin: [0, 5, 0, 0] }
                                    ],
                                    width: '25%'
                                }
                            ],
                            margin: [2, 5, 2, 5]
                        }
                    ]
                ]
            },
            layout: {
                hLineWidth: () => 0.5,
                vLineWidth: () => 0.5,
                hLineColor: () => '#E9ECEF',
                vLineColor: () => '#E9ECEF'
            }
        };
    }

    /**
     * Alan kutusu oluşturur
     */
    createField(label, value, width, isMultiline = false) {
        return {
            table: {
                widths: ['*'],
                heights: [15],
                body: [
                    [
                        {
                            stack: [
                                { text: label, fontSize: 7, color: '#666666' },
                                { text: value || '-', fontSize: 9, bold: true, margin: [0, 2, 0, 0] }
                            ],
                            margin: [2, 2, 2, 2]
                        }
                    ]
                ]
            },
            layout: {
                hLineWidth: () => 0.5,
                vLineWidth: () => 0.5,
                hLineColor: () => '#E9ECEF',
                vLineColor: () => '#E9ECEF'
            },
            width: width
        };
    }

    viewPdf(pdfDoc) {
        pdfDoc.open();
    }

    downloadPdf(pdfDoc, filename = 'parca-iade-formu.pdf') {
        pdfDoc.download(filename);
    }
}

export default ReturnRequestPdfFormPdfMake;

